(function () {
  'use strict';
  if (window.LDAdProductsLoaded) return;
  window.LDAdProductsLoaded = true;
  var context = window.LDAdContext || {};
  var code = context.code;
  var filmCollections = {"W1010B001":"wzory-z-filmu-vd01","W1010B002":"wzory-z-filmu-vd02","W1010B003":"wzory-z-filmu-vd03","W1010B004":"wzory-z-filmu-vd04","W1010B005":"wzory-z-filmu-vd05","W1010B006":"wzory-z-filmu-vd06","W1010B007":"wzory-z-filmu-vd07","W1010B008":"wzory-z-filmu-vd08","W1010B009":"wzory-z-filmu-vd09","W1010B00A":"wzory-z-filmu-vd10","W1010B00B":"wzory-z-filmu-vd11","W1010B00C":"wzory-z-filmu-vd12","W1010B00D":"wzory-z-filmu-vd13","W1010B00E":"wzory-z-filmu-vd14"};
  var collectionHandle = filmCollections[code] || (code ? 'ad-' + code.toLowerCase() : '');
  if (!code || context.expired) return;
  var jobs = new WeakSet();
  var requests = new Map();
  function afterDomReady(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(callback, 0); }, { once: true });
    else setTimeout(callback, 0);
  }
  function release() {
    clearTimeout(context.timer);
    document.documentElement.classList.remove('ld-ad-pending');
    document.dispatchEvent(new CustomEvent('ld:ad:release'));
  }
  function cardsOf(grid) {
    return grid ? Array.from(grid.children).filter(function (node) { return node.hasAttribute('data-ld-product-id'); }) : [];
  }
  function availableCard(card) {
    return card.dataset.ldProductAvailable === 'true';
  }
  function prepareImages(scope) {
    Array.from(scope.querySelectorAll('img')).forEach(function (img, index) {
      img.loading = 'eager';
      if (index < 2) img.setAttribute('fetchpriority', 'high');
    });
  }
  function uniqueIDs(scope, suffix) {
    var replacements = new Map();
    scope.querySelectorAll('[id]').forEach(function (node, index) {
      var old = node.id, next = old + '-ld-ad-' + suffix + '-' + index;
      replacements.set(old, next); node.id = next;
    });
    scope.querySelectorAll('[for],[form],[aria-controls],[aria-labelledby],[aria-describedby],[href^="#"]').forEach(function (node) {
      ['for', 'form', 'aria-controls', 'aria-labelledby', 'aria-describedby'].forEach(function (attribute) {
        if (node.hasAttribute(attribute)) node.setAttribute(attribute, node.getAttribute(attribute).split(/\s+/).map(function (id) { return replacements.get(id) || id; }).join(' '));
      });
      var href = node.getAttribute('href');
      if (href && replacements.has(href.slice(1))) node.setAttribute('href', '#' + replacements.get(href.slice(1)));
    });
  }
  function requestKey(root) {
    var theme = window.Shopify && Shopify.theme ? Shopify.theme.id : '';
    var meta = root.querySelector('[data-ld-feed-meta]');
    var currency = meta ? JSON.parse(meta.textContent).currency : '';
    return [theme, root.dataset.ldSection, document.documentElement.lang, currency, code].join(':');
  }
  async function load(root) {
    var key = requestKey(root);
    if (requests.has(key)) return requests.get(key);
    var job = (async function () {
      var base = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
      var url = new URL(base + 'collections/' + collectionHandle, location.origin);
      url.searchParams.set('view', 'ld-all-patterns');
      url.searchParams.set('section_id', root.dataset.ldSection);
      url.searchParams.set('filter.v.availability', '1');
      if (window.Shopify && Shopify.theme && Shopify.theme.role !== 'main') url.searchParams.set('preview_theme_id', Shopify.theme.id);
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); }, 5000);
      try {
        var html = [], page = 1;
        while (url) {
          var response = await fetch(url.href, { signal: controller.signal, credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) return null;
          var source = new DOMParser().parseFromString(await response.text(), 'text/html');
          var returned = source.querySelector('[data-ld-collection]');
          var grid = returned && returned.querySelector('[data-ld-product-grid]');
          var metaNode = returned && returned.querySelector('[data-ld-feed-meta]');
          if (!grid || !metaNode) return null;
          var meta = JSON.parse(metaNode.textContent), cards = cardsOf(grid);
          if (meta.path !== base + 'collections/' + collectionHandle || meta.page !== page || cards.length !== meta.rendered) return null;
          cards.filter(availableCard).forEach(function (card) { html.push(card.outerHTML); });
          if (meta.next) { page++; url.searchParams.set(meta.pageParam, page); } else url = null;
        }
        if (!html.length) return null;
        return html.join('');
      } finally { clearTimeout(timer); }
    })();
    requests.set(key, job);
    try { return await job; }
    finally { requests.delete(key); }
  }
  function hideDuplicates(ids) {
    var selectors = ids.filter(function (id) { return /^\d+$/.test(id); }).map(function (id) {
      return '[data-ld-product-grid]>[data-ld-product-id="' + id + '"]';
    });
    if (!selectors.length) return;
    var style = document.createElement('style');
    style.setAttribute('data-ld-ad-duplicates', '');
    style.textContent = selectors.join(',') + '{display:none!important}';
    document.head.appendChild(style);
  }
  function finish(root, slot, grid, seen) {
    var normalGrid = root.querySelector('[data-ld-product-grid]');
    if (normalGrid) cardsOf(normalGrid).forEach(function (card) {
      if (seen.has(card.dataset.ldProductId)) { card.setAttribute('data-ld-ad-duplicate', ''); card.hidden = true; }
    });
    if (window.LDCollectionFeed && LDCollectionFeed.prepare) LDCollectionFeed.prepare(grid);
    var heading = slot.querySelector('.ld-ad-products__title');
    root.querySelectorAll('[data-ld-pagination] a').forEach(function (link) {
      var url = new URL(link.href); url.hash = heading.id; link.href = url.href;
    });
  }
  async function mount(root) {
    var slot = root.querySelector('[data-ld-ad-slot]');
    if (!slot || jobs.has(root)) return;
    jobs.add(root); root.dataset.ldAdState = 'loading';
    try {
      var html = await load(root);
      if (!html || !root.isConnected || context.expired) { root.dataset.ldAdState = 'empty'; return; }
      var staging = document.createElement('template'); staging.innerHTML = html;
      var cards = Array.from(staging.content.children);
      var normalGrid = root.querySelector('[data-ld-product-grid]');
      var grid = document.createElement('ul');
      grid.className = normalGrid ? normalGrid.className : 'grid product-grid grid--2-col-tablet-down grid--4-col-desktop';
      grid.setAttribute('data-ld-ad-grid', ''); grid.setAttribute('role', 'list');
      var seen = new Set();
      cards.forEach(function (card, index) {
        var id = card.dataset.ldProductId;
        if (!id || seen.has(id) || !availableCard(card)) return;
        seen.add(id); uniqueIDs(card, root.dataset.ldSection + '-' + index);
        card.querySelectorAll('script:not([type="application/json"])').forEach(function (script) { script.remove(); });
        grid.appendChild(card);
      });
      if (!seen.size) { root.dataset.ldAdState = 'empty'; return; }
      prepareImages(grid);
      if (context.expired || !root.isConnected) { root.dataset.ldAdState = 'empty'; return; }
      root.dataset.ldAdIds = Array.from(seen).join(',');
      hideDuplicates(Array.from(seen));
      slot.querySelector('[data-ld-ad-cards]').replaceChildren(grid);
      slot.dataset.ldAdReady = 'true'; slot.hidden = false;
      root.dataset.ldAdState = 'ready';
      root.dispatchEvent(new CustomEvent('ld:ad:ready', { bubbles: true }));
      afterDomReady(function () { finish(root, slot, grid, seen); });
    } catch (_) { root.dataset.ldAdState = 'empty'; }
    finally { release(); }
  }
  function boot(scope, final) {
    var roots = Array.from(scope.querySelectorAll('[data-ld-collection]'));
    if (scope.matches && scope.matches('[data-ld-collection]')) roots.unshift(scope);
    roots.forEach(mount);
    if (!roots.length && final) release();
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target, true); });
  boot(document, document.readyState !== 'loading');
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document, true); }, { once: true });
})();